"use strict";

var _classCallCheck = require("/Users/adamhpan/Desktop/code/personal-portfolio/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/adamhpan/Desktop/code/personal-portfolio/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RollUpdater = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

function updateRoll(particle, delta) {
  var roll = particle.options.roll;

  if (!particle.roll || !roll.enable) {
    return;
  }

  var speed = particle.roll.speed * delta.factor;
  var max = 2 * Math.PI;
  particle.roll.angle += speed;

  if (particle.roll.angle > max) {
    particle.roll.angle -= max;
  }
}

var RollUpdater = /*#__PURE__*/function () {
  function RollUpdater() {
    _classCallCheck(this, RollUpdater);
  }

  _createClass(RollUpdater, [{
    key: "init",
    value: function init(particle) {
      var rollOpt = particle.options.roll;

      if (rollOpt.enable) {
        particle.roll = {
          angle: Math.random() * Math.PI * 2,
          speed: (0, Utils_1.getRangeValue)(rollOpt.speed) / 360
        };

        if (rollOpt.backColor) {
          particle.backColor = (0, Utils_1.colorToHsl)(rollOpt.backColor);
        } else if (rollOpt.darken.enable && rollOpt.enlighten.enable) {
          var alterType = Math.random() >= 0.5 ? Enums_1.AlterType.darken : Enums_1.AlterType.enlighten;
          particle.roll.alter = {
            type: alterType,
            value: alterType === Enums_1.AlterType.darken ? rollOpt.darken.value : rollOpt.enlighten.value
          };
        } else if (rollOpt.darken.enable) {
          particle.roll.alter = {
            type: Enums_1.AlterType.darken,
            value: rollOpt.darken.value
          };
        } else if (rollOpt.enlighten.enable) {
          particle.roll.alter = {
            type: Enums_1.AlterType.enlighten,
            value: rollOpt.enlighten.value
          };
        }
      } else {
        particle.roll = {
          angle: 0,
          speed: 0
        };
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var roll = particle.options.roll;
      return !particle.destroyed && !particle.spawning && roll.enable;
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateRoll(particle, delta);
    }
  }]);

  return RollUpdater;
}();

exports.RollUpdater = RollUpdater;